
<div style="position: relative; border-top-color: lightgray; border-top-style: solid; border-top-width: 1px;"  v-resize="onResize">
    <v-row class="no-frame w-100">
         <v-col class="no-border col-9 v-flex" style="position: relative">
             <p-inc-bounced-mail
                 v-model       = "mail.visible"
                 :bounced-mail = mail.content
                 :height       = "mailHeight"
             />

            <div class="todo-layout">
                <div class="todo-units-total" :style="'height:' + height + 'px'">
                    <p-inc-units-total
                        :loading = "loading"
                        @changed = "onChanged"
                        @bounce  = "onBounce"
                    />
                </div>
                <div class="todo-groups-container">
                    <div class="todo-groups-toolbar">
                        <a @click.stop = "onRefresh" class="v-flex" v-if="isPrivileged">
                            <v-icon
                                :size  = "24"
                                color = "primary"
                            >
                                mdi-refresh
                            </v-icon>

                            <div>
                                {{ $t('common.refresh') }}
                            </div>
                        </a>
                        <v-spacer />
                        <v-switch
                            v-model = "onlyLM"
                            label   = "nur Anlagen im Liftmanagement"
                            color   = "primary"
                            :ripple = "false"
                            hide-details
                            class = "mt-0 pt-0"
                        />
                    </div>

                    <div class="todo-groups-grid">
                        <p-inc-measure-group
                            title     = "Ereignisse"
                            :measures = "incMeasures"
                            @click    = "onMeasure"
                        />

                        <c-lgs-event-group
                            :title    = "$t('todo.lgs.title')"
                            :measures = "lgsMeasures"
                            @click    = "onMeasure"
                        />

                        <p-inc-measure-group
                            title     = "ZÜS Prüfungen"
                            :measures = "assMeasures"
                            @click    = "onMeasure"
                        />

                        <p-inc-measure-group
                            v-if      = "isGuardReports"
                            title     = "Aufzugswärter Prüfungen"
                            :measures = "guardMeasures"
                            @click    = "onMeasure"
                        />
                    </div>
                </div>
            </div>
        </v-col>
        <v-col class="no-border col-3" style="padding-left: 24px">
            <v-expand-x-transition>
                <p-inc-assessment-delay-iterator
                    v-if        = "visible.delay"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-required-fields-iterator
                    v-if        = "visible.missing"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-site-down-iterator
                    v-if        = "visible.unitdown"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-open-incident-iterator
                    v-if        = "visible.open"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    type        = "OPEN_INCIDENTS"
                    :title      = "$t('todo.open.title')"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-open-incident-iterator
                    v-if        = "visible.assessments"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    type        = "OPEN_ASSESSMENTS"
                    :title      = "$t('todo.assessment.maintitle')"
                    class       = "home-column"
                    @site       = "onSite"
                />

                <p-inc-open-incident-iterator
                    v-if        = "visible.invoices"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    type        = "OPEN_INVOICES"
                    :title      = "$t('todo.invoices.title')"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-open-incident-iterator
                    v-if        = "visible.maintenances"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    type        = "OPEN_MAINTENANCES"
                    :title      = "$t('todo.maintenance.title')"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-open-incident-iterator
                    v-if        = "visible.guardOpen"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    type        = "GUARD_OPEN"
                    :title      = "$t('todo.guard.open.title')"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-open-incident-iterator
                    v-if        = "visible.guardImported"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    type        = "GUARD_IMPORTED"
                    :title      = "$t('todo.guard.imported.title')"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-assessment-iterator
                    v-if        = "visible.minor"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :type       = "2"
                    :title      = "$t('todo.assessment.title.minor')"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-assessment-iterator
                    v-if        = "visible.middle"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :type       = "3"
                    :title      = "$t('todo.assessment.title.middle')"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-assessment-iterator
                    v-if        = "visible.major"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :type       = "4"
                    :title      = "$t('todo.assessment.title.major')"
                    :all        = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-assessment-iterator
                    v-if            = "visible.canceled"
                    :top-height.    = "topHeight"
                    :customer       = "todoState.selectedCustomer"
                    :type           = "5"
                    :title          = "$t('todo.assessment.title.canceled')"
                    :all            = "todoState.allCustomer"
                    :liftmanagement = "onlyLM"
                    class           = "home-column"
                    @site           = "onSite"
                />
                <p-inc-bounced-mail-iterator
                    v-if        = "visible.bounced"
                    :top-height = "topHeight"
                    class       = "home-column"
                    @site       = "onSite"
                    @mail       = "onMail"
                />
                <p-lgs-iterator
                    v-if        = "visible.standstill"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    event-type  = "STANDSTILL"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-lgs-iterator
                    v-if        = "visible.longStandstill"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    event-type  = "LONG_STANDSTILL"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-lgs-iterator
                    v-if        = "visible.unknown"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    event-type  = "UNKNOWN"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-lgs-iterator
                    v-if        = "visible.resolved"
                    :top-height = "topHeight"
                    :customer   = "todoState.selectedCustomer"
                    :all        = "todoState.allCustomer"
                    event-type  = "RECENTLY_RECOVERED"
                    class       = "home-column"
                    @site       = "onSite"
                />
                <p-inc-guard-protocol-failed-iterator
                    v-if             = "visible.guardFailed"
                    :customer        = "todoState.selectedCustomer"
                    :top-height      = "topHeight"
                    :liftmanagement  = "onlyLM"
                    class            = "home-column"
                    @assigned        = "onGuardProtocolAssigned"
                    @deleted         = "onGuardProtocolDeleted"
                />
            </v-expand-x-transition>
        </v-col>
    </v-row>
</div>
